import { type IApiResponse } from '@/helpers/types';
import { type IAuditTrailUserStates } from '@/helpers/types/IAuditTrailState';

import { coreApiSlice } from '../apiSlice';

export const auditTrailApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAuditTrailUser: builder.mutation<IApiResponse<IAuditTrailUserStates>, { params: Record<string, any> }>({
			query: ({ params }) => ({
				method: 'GET',
				url: '/AuditTrail/user?Type=create&Type=update&Type=delete',
				params,
			}),
		}),
		getAllAuditTrail: builder.mutation<IApiResponse, { params: Record<string, any> }>({
			query: ({ params }) => ({
				method: 'GET',
				url: '/AuditTrail/GetAll?Type=create&Type=update&Type=delete',
				params,
			}),
		}),
	}),
});

export const { useGetAuditTrailUserMutation, useGetAllAuditTrailMutation } = auditTrailApiSlice;
